module.exports = __webpack_public_path__ + "static/media/maf-46.c63f2dc4.png";